import { Chip } from '@material-ui/core'
import Cancel from 'mdi-react/CancelIcon'
import CheckboxMarkedCircleOutlineIcon from 'mdi-react/CheckboxMarkedCircleOutlineIcon'

const CustomChip = ({
  value,
  label,
  style
}: {
  value: string | boolean
  label: string
  style?: any
}) => (
  <Chip
    icon={
      value ? (
        <CheckboxMarkedCircleOutlineIcon style={{ color: '#fff' }} />
      ) : (
        <Cancel />
      )
    }
    label={label}
    {...(value
      ? {
        style: {
          backgroundColor: '#46816C',
          color: '#fff',
          ...style
        }
      }
      : {
        color: 'secondary',
        style
      })}
  />
)

export default CustomChip
